var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"sample-video"},[_c('iframe',{attrs:{"src":("https://content.jwplatform.com/previews/" + (_vm.props.videoId) + "-T92WUUWc"),"itemprop":"video","height":"1080","width":"1920","frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }